/**
 * @fileoverview Pure helpers for TodayViewPanels visibility and upcoming unlock.
 */
import {
  persistUpcomingUnlocked,
} from '@/features/today/utils/upcomingUnlock';
import { shouldShowNextActionPanel } from '@/features/tasks/utils/views/nextActionUtils';

/**
 * @param {{
 *   todayEmpty: boolean,
 *   displayUpcomingTasks: import('@/types').Task[],
 *   upcomingUnlocked: boolean,
 *   setUpcomingUnlocked: (value: boolean) => void,
 * }} args
 */
export function applyUpcomingUnlockIfNeeded({
  todayEmpty,
  displayUpcomingTasks,
  upcomingUnlocked,
  setUpcomingUnlocked,
}) {
  if (todayEmpty && displayUpcomingTasks.length > 0 && !upcomingUnlocked) {
    setUpcomingUnlocked(true);
    persistUpcomingUnlocked();
  }
}

/**
 * @param {{
 *   upcomingUnlocked: boolean,
 *   displayUpcomingTasks: import('@/types').Task[],
 *   nextActions: import('@/types').Task[] | null | undefined,
 *   tasksMap: Record<string, import('@/types').Task>,
 * }} args
 */
export function getTodayPanelsVisibility({
  upcomingUnlocked,
  displayUpcomingTasks,
  nextActions,
  tasksMap,
}) {
  const showUpcoming = upcomingUnlocked && displayUpcomingTasks.length > 0;
  const showNextAction = (nextActions?.length ?? 0) > 0;
  const nextActionHintEligible =
    showNextAction && shouldShowNextActionPanel(tasksMap);
  return { showUpcoming, showNextAction, nextActionHintEligible };
}

export const TODAY_PANEL_FLAT_CLASS = 'panel-flat-list';

/** Today panels: headers stay clickable but out of tab order; tasks are the tab stops. */
export const TODAY_PANEL_A11Y = { headerTabIndex: -1 };
